/* Seoul C9 lead-time standard v1. One canonical source, one saved value per cart line. */
(() => {
  'use strict';
  const pending = new Map();
  const records = new Map();
  const SOURCE_LOCALES = ['zh-hant', 'zh-tw'];
  const UNKNOWN = '待確認 / To be confirmed';
  function standardize(raw) {
    const text = (raw || '').trim().replace(/\s+/g, ' ');
    if (!text) return UNKNOWN;
    const clean = text.replace(/[‼!！️📦]/gu, '').trim();
    if (/^(現貨(發售|供應|出售)?|現貨中)$/u.test(clean)) {
      return '現貨（備貨時間待確認） / In stock (preparation time to be confirmed)';
    }
    const range = clean.match(/^(?:約|預計|預購)?\s*(\d+)\s*(?:[-–—至~～]\s*(\d+))?\s*(周|週|星期|天|日|個月|月)\s*(?:到貨|內到貨|左右到貨|左右)?$/u);
    if (range) {
      const low = Number(range[1]);
      const high = Number(range[2] || range[1]);
      if (low > 0 && high >= low) {
        const amount = low === high ? String(low) : low + '–' + high;
        const unit = /周|週|星期/u.test(range[3]) ? ['星期', 'weeks'] : /月/u.test(range[3]) ? ['個月', 'months'] : ['天', 'days'];
        return '預計到店／備貨：約 ' + amount + ' ' + unit[0] + ' / Estimated store arrival / preparation: ' + amount + ' ' + unit[1];
      }
    }
    // Preserve meaningful notes and complex estimates exactly; never invent a range.
    return '商品交期（原始資料） / Product lead time (original details): ' + text;
  }
  function sourceRecord(raw) {
    return {raw: raw || '', display: standardize(raw), recordedAt: new Date().toISOString()};
  }
  function sourceFor(widget) {
    const id = widget.dataset.productId;
    if (records.has(id)) return Promise.resolve(records.get(id));
    if (pending.has(id)) return pending.get(id);
    if (SOURCE_LOCALES.includes((widget.dataset.sourceLocale || '').toLowerCase())) {
      const record = sourceRecord(widget.dataset.leadRaw);
      records.set(id, record);
      return Promise.resolve(record);
    }
    const promise = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const url = new URL('/zh-hant/products/' + encodeURIComponent(widget.dataset.productHandle), location.origin);
        const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        const response = await fetch(url.href, {credentials: 'same-origin', signal: controller.signal, cache: 'no-store'});
        if (!response.ok) throw new Error('Source unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = Array.from(html.querySelectorAll('[data-c9-lead-source]')).find(el => el.dataset.productId === id && SOURCE_LOCALES.includes((el.dataset.sourceLocale || '').toLowerCase()));
        if (!source) throw new Error('Canonical source missing');
        const record = sourceRecord(source.dataset.leadRaw);
        records.set(id, record);
        return record;
      } catch (_) {
        // A failed source lookup is explicit, rather than silently using a conflicting translation.
        const record = {raw: '', display: UNKNOWN + '（交期資料暫未確認 / lead-time details unavailable）', recordedAt: new Date().toISOString()};
        records.set(id, record);
        return record;
      } finally { clearTimeout(timeout); }
    })();
    pending.set(id, promise);
    return promise;
  }
  function setProperty(widget, name, value) {
    let input = Array.from(widget.querySelectorAll('input')).find(el => el.name === 'properties[' + name + ']');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'properties[' + name + ']'; widget.append(input); }
    input.value = value;
  }
  function apply(widget, record) {
    widget.querySelector('[data-c9-lead-display]').textContent = record.display;
    setProperty(widget, 'Lead Time', record.display);
    setProperty(widget, '_c9_lead_time_raw', record.raw);
    setProperty(widget, '_c9_lead_time_recorded_at', record.recordedAt);
    widget.dataset.c9Ready = 'true';
    const section = widget.closest('[data-section-type="product"]');
    if (section) {
      // Replace only existing lead-time metafield displays that match this product's original value.
      section.querySelectorAll('.metafield-multi_line_text_field').forEach(el => {
        if (el.textContent.trim() === (widget.dataset.leadRaw || '').trim()) el.textContent = record.display;
      });
    }
  }
  function scan() {
    document.querySelectorAll('[data-c9-lead-source]').forEach(widget => {
      if (widget.dataset.c9Initialized) return;
      widget.dataset.c9Initialized = 'true';
      widget.c9ReadyPromise = sourceFor(widget).then(record => apply(widget, record));
    });
  }
  function widgetFor(target) {
    const form = target && target.closest && target.closest('form');
    return form && form.querySelector('[data-c9-lead-source]');
  }
  document.addEventListener('click', event => {
    const target = event.target.closest && event.target.closest('[data-add-to-cart], button[type="submit"], shopify-accelerated-checkout, .shopify-payment-button');
    if (!target) return;
    const widget = widgetFor(target);
    if (!widget || widget.dataset.c9Ready === 'true') return;
    event.preventDefault(); event.stopImmediatePropagation();
    scan();
    widget.c9ReadyPromise.then(() => target.click());
  }, true);
  document.addEventListener('submit', event => {
    const widget = event.target.querySelector('[data-c9-lead-source]');
    if (!widget || widget.dataset.c9Ready === 'true') return;
    event.preventDefault(); event.stopImmediatePropagation();
    scan();
    const submitter = event.submitter;
    widget.c9ReadyPromise.then(() => event.target.requestSubmit(submitter || undefined));
  }, true);
  scan();
  new MutationObserver(scan).observe(document.documentElement, {childList: true, subtree: true});
})();
